import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import styles from './NavBar.module.scss';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

const NavBar = () => {
  const { lang } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [activeBackground, setActiveBackground] = useState(false);
  const [hideNavbar, setHideNavbar] = useState(false);

  useEffect(() => {
    let currentScroll = 0;
    let screenHeight = window.innerHeight;
    const onScroll = () => {
      currentScroll = window.pageYOffset;
      if (currentScroll > screenHeight) {
        setActiveBackground(true);
      } else {
        setActiveBackground(false);
      }

      if (currentScroll > 120) {
        setHideNavbar(true);
      } else {
        setHideNavbar(false);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  function scrollToSection(id) {
    const el = document.getElementById(id);
    el?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    });
  }

  return (
    <Container
      fluid
      className={`${styles.navbarWrapper} ${
        activeBackground && styles.activeBackground
      } ${hideNavbar && styles.hideNavbar}`}
    >
      <Container className={styles.sectionWrap}>
        <Row className={styles.row}>
          <Col className={styles.wrap}>
            <div
              onClick={() => {
                navigate('/');
                scrollToSection('home');
              }}
              className={styles.logoWrap}
            >
              <img
                src={require('../../../images/mt-logo-orange.png')}
                alt='Modern Tribe Events logo'
              />
            </div>

            <div
              className={`${styles.buttonWrap}`}
              style={{ display: hideNavbar ? 'block' : 'none' }}
            >
              <Button
                className={styles.btnPrimary}
                as={Link}
                to={`/${lang}/${t('register')}`}
              >
                <Trans i18nKey='register_label' />
              </Button>
            </div>

            <div
              className={`${styles.langWrap}`}
              style={{ display: hideNavbar ? 'none' : 'block' }}
            >
              {lang === 'pl' ? (
                <Button className={styles.btnPrimary} as={Link} to='/en'>
                  EN
                </Button>
              ) : (
                <Button className={styles.btnPrimary} as={Link} to='/pl'>
                  PL
                </Button>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default NavBar;
